/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** sync status enum */
export enum SyncStatus {
  UNSYNC = "UNSYNC",
  SYNCING = "SYNCING",
  SYNCED = "SYNCED",
}

/** activity status */
export enum SearchTypeEnum {
  POST = "POST",
  TOPIC = "TOPIC",
  USER = "USER",
  STORY = "STORY",
  MEDIA = "MEDIA",
  EVENT = "EVENT",
  COMMUNITY = "COMMUNITY",
  HASHTAG = "HASHTAG",
  POST_HASHTAG = "POST_HASHTAG",
  OPEN_DATA = "OPEN_DATA",
}

/** relation status enum */
export enum RelationStatusEnum {
  ENABLE = "ENABLE",
  DISABLE = "DISABLE",
}

/** relation role enum */
export enum RelationRoleEnum {
  OWNER = "OWNER",
  MEMBER = "MEMBER",
  ADMIN = "ADMIN",
  MODERATOR = "MODERATOR",
}

/** transaction status */
export enum OwnerStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/** badge check status enum */
export enum ClaimableBadgeSortEnum {
  LEVEL_DESC = "LEVEL_DESC",
  LEVEL_ASC = "LEVEL_ASC",
}

/**
 * business type
 * @default "OWNER"
 */
export enum BusinessTypeEnum {
  OWNER = "OWNER",
  DAPP = "DAPP",
  OSP_TO_PLATFORM = "OSP_TO_PLATFORM",
}

/** type */
export enum BindTypeEnum {
  DISCORD = "DISCORD",
  TWITTER = "TWITTER",
  YOUTUBE = "YOUTUBE",
  TELEGRAM = "TELEGRAM",
  WALLET = "WALLET",
  TIKTOK = "TIKTOK",
  INSTAGRAM = "INSTAGRAM",
}

/** type */
export enum BindLinkTypeEnum {
  BIND_TELEGRAM = "BIND_TELEGRAM",
  JOIN_TELEGRAM_GROUP = "JOIN_TELEGRAM_GROUP",
  JOIN_DISCORD_GROUP = "JOIN_DISCORD_GROUP",
  BIND_TWITTER = "BIND_TWITTER",
  BIND_DISCORD = "BIND_DISCORD",
  BIND_YOUTUBE = "BIND_YOUTUBE",
}

/** badge check status enum */
export enum BadgeStatus {
  PENDING = "PENDING",
  CLAIMABLE = "CLAIMABLE",
  CLAIMED = "CLAIMED",
  FAILED = "FAILED",
}

/** Wear Badge */
export interface Badge {
  /** id */
  id?: string;
  /** name */
  name?: string;
  /** chain id */
  icon?: string;
  /** level */
  level?: number;
  /**
   * created
   * @format int64
   */
  created?: number;
}

export interface BaseResponse {
  /** sub code */
  code?: number;
  /** information for the response */
  msg?: string;
  data?: object;
  errors?: Error[];
}

export interface Bind {
  /** owner id */
  owner_id?: string;
  /** platform id */
  platform_id?: string;
  /** platform */
  platform?: BindTypeEnum;
  /** name */
  name?: string;
  /**
   * bind time
   * @format int64
   */
  bind_time?: number;
  /** eoa address */
  eoa_address?: string;
  /** true already occupied */
  occupied?: boolean;
  /** profile */
  profile?: ProfileDTO[];
  /** is sync to osp */
  sync_to_osp?: boolean;
  /** is sync to platform */
  sync_to_platform?: boolean;
  /** is have credential */
  have_credential?: boolean;
  space_ids?: string[];
  /** platform smart followers count */
  platform_smart_followers_count?: number;
  /** platform verified type,eg - blue|government|business|none */
  platform_verified_type?: string;
  /** platform of registration */
  registration_platform?: string;
  /**
   * flag
   * @format int64
   */
  flag?: number;
  platform_info?: Record<string, any>;
  /** multiple items of the platform */
  platform_items?: any[];
  /** Owner info */
  owner?: Owner;
}

export type BindResponse = BaseResponse & {
  data?: Bind;
};

export interface Binds {
  rows?: Bind[];
}

export type BindsResponse = BaseResponse & {
  data?: Binds;
};

/** app info */
export interface ClaimableBadge {
  /** badge id */
  id?: string;
  /** chain id */
  chain_id?: string;
  /** badge display name */
  name?: string;
  /** badge nft token id */
  token_id?: string;
  /** @format int64 */
  level?: number;
  /** title */
  title?: string;
  /** background */
  background?: string;
  /** badge image */
  image?: string;
  /** badge icon */
  icon?: string;
  /** un claim badge image */
  un_claim_image?: string;
  /** series id */
  series?: string;
  /** category */
  category?: string;
  progress?: {
    /** name */
    name?: string;
    /** type */
    type?: string;
    /** user current value */
    value?: string;
    /** user condition gold value */
    condition?: string;
  }[];
  /** strategy */
  strategy?: string;
  /** strategy */
  description?: string;
  /** badge check status enum */
  status?: BadgeStatus;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modify?: number;
  /** @format int64 */
  claim_time?: number;
}

export interface ClaimableBadgePagination {
  /**
   * limit
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total default 0
   * @format int32
   */
  total?: number;
  /** next token */
  next_token?: string;
  rows?: ClaimableBadge[];
}

export type ClaimableBadgePaginationResponse = BaseResponse & {
  data?: ClaimableBadgePagination;
};

/** userDoc */
export interface CommunityDoc {
  /** id */
  id?: string;
  /** gid */
  gid?: string;
  /**
   * time of create
   * @format int64
   */
  created?: number;
  /** chain_id */
  chain_id?: string;
  /** bind_app_id */
  bind_app_id?: string;
  /** display_name */
  display_name?: string;
  /** desc */
  desc?: string;
  /** unique_name */
  unique_name?: string;
  /** banner */
  banner?: string;
  /** user_id */
  user_id?: string;
  /** user_gid */
  user_gid?: string;
  /** logo */
  logo?: string;
  /** join_nft */
  join_nft?: string;
  /** tags */
  tags?: string;
  address?: string;
  owner_id?: string;
  profile_id?: string;
  /** activity_tags */
  activity_tags?: string;
  /**
   * view_count
   * @format int32
   */
  view_count?: number;
  /**
   * activity_count
   * @format int32
   */
  activity_count?: number;
  /**
   * member_count
   * @format int64
   */
  member_count?: number;
  /** high light */
  highlight?: Record<string, string[]>;
  /** @format int64 */
  dapp_type?: number;
  /** userDoc */
  user?: UserDoc;
}

export interface Dispatcher {
  /** wallet address of dispatcher */
  address?: string;
  /** use the built-in dispatcher on the API */
  canRelay?: boolean;
}

export interface DocGroupPagination {
  rows?: GroupDoc[];
}

export type DocGroupPaginationResponse = BaseResponse & {
  data?: DocGroupPagination;
};

export type DocMultiplePaginationResponse = BaseResponse & {
  data?: Record<string, DocPagination>;
};

export interface DocPagination {
  /**
   * 每次请求数
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int64
   */
  totalCount?: number;
  /**
   * 翻页offset
   * @format int32
   */
  offset?: number;
  rows?: (UserDoc | PostDoc | CommunityDoc | HashtagDoc | OpenPostDoc)[];
}

export interface Error {
  /** error type, eg. Generic, InvalidRequest, ClientForbidden */
  reason?: string;
  /** human-friendly message */
  detail?: string;
  /** chart */
  location?: string;
  /** parameter */
  locationType?: string;
}

export interface Fac {
  /**
   * amount
   * @format int64
   */
  amount?: number;
  /**
   * project id
   * @format int32
   */
  project_id?: number;
  /** published time */
  published_time?: string;
  /** name */
  name?: string;
  /** Logo */
  logo?: string;
  /** rounds */
  rounds?: string;
  /** invests */
  invests?: Investor[];
  social_media?: SocialMediaAddress;
  /** token symbol */
  token_symbol?: string;
  contract_address?: {
    /** id */
    id?: string;
    /** token address */
    address?: string;
    /** platform */
    platform?: string;
  }[];
  /** @format int64 */
  valuation?: number;
}

export interface FacPagination {
  /**
   * limit
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total default 0
   * @format int32
   */
  total?: number;
  /** next token */
  next_token?: string;
  rows?: Fac[];
}

export type FacPaginationResponse = BaseResponse & {
  data?: FacPagination;
};

/** groupDoc */
export interface GroupDoc {
  /** group key */
  key?: string;
  /**
   * group count
   * @format int64
   */
  count?: number;
  object?: object;
}

/** hashtagDTO */
export interface HashtagDoc {
  /** hashtag */
  hashtag?: string;
  /** high light */
  highlight?: Record<string, string[]>;
}

export interface Investor {
  /** name */
  name?: string;
  /** Logo */
  logo?: string;
  /** root data url */
  root_data_url?: string;
  /**
   * lead investor
   * @format int32
   */
  lead_investor?: number;
}

/** joiningCommunity */
export interface JoiningCommunity {
  /** community id */
  community_id?: string;
  /** community gid */
  community_gid?: string;
  /** relation role enum */
  role?: RelationRoleEnum;
  /** join time */
  join_time?: string;
  /** relation status enum */
  status?: RelationStatusEnum;
}

export interface Kline {
  /**
   * timestamp
   * @format int64
   */
  timestamp?: number;
  /** price */
  price?: string;
}

export type KlineResponse = BaseResponse & {
  data?: object;
};

export interface KolFollow {
  /** type mention,follow */
  type?: string;
  /**
   * time
   * @format int64
   */
  time?: number;
  /** people id */
  people_id?: string;
  /** name */
  name?: string;
  /** screen name */
  screenName?: string;
  /** profile image url https */
  profileImageUrlHttps?: string;
  /**
   * related post count
   * @format int64
   */
  relatedPostCount?: number;
  /** token handle */
  token_handle?: string;
  /** token image */
  token_image?: string;
  /** post id */
  post_id?: string;
}

export interface KolFollowPagination {
  /**
   * request data count
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total
   * @format int32
   */
  total?: number;
  /** next token */
  next_token?: string;
  rows?: KolFollow[];
}

export type KolFollowPaginationResponse = BaseResponse & {
  data?: KolFollowPagination;
};

export interface Media {
  /** id for resource */
  id?: string;
  /** media url */
  display_url?: string;
  /** media url */
  media_url?: string;
  /** http url */
  media_url_https?: string;
  /** mimeType of media format, image/gif ,video/mp4, audio/mp3 */
  type?: string;
  /** native/twitter/giphy */
  source?: string;
  /** link */
  link?: string;
  /** url */
  url?: string;
  /** json format sizes */
  sizes?: string;
  /** extra cover url */
  extra?: string;
  /** mimeType of media format, image/gif ,video/mp4, audio/mp3 */
  mime_type?: string;
  /** cover url */
  cover?: string;
}

export interface OpenDataToken {
  id?: string;
  chain_image_url?: string;
  name?: string;
  symbol?: string;
  /** @format int64 */
  token_created_at?: number;
  market_cap?: string;
  liquidity?: string;
  fdv?: string;
  socials?: {
    image_url?: string;
    website?: string;
    twitter?: string;
    telegram?: string;
  };
  engaged_influencers?: {
    nick_name?: string;
    handle?: string;
    avatar?: string;
    related_post_count?: number;
    operations?: {
      /** follow/mention */
      type?: string;
      /** @format int64 */
      operate_time?: number;
    }[];
  }[];
  pools?: TokenPool[];
  trade?: TokenPoolTrade;
  favorite?: boolean;
  sparkline?: Kline[];
  summary?: string;
}

export interface OpenDataTokenPagination {
  /** @format int32 */
  total?: number;
  rows?: OpenDataToken[];
}

export type OpenDataTokenPaginationResponse = BaseResponse & {
  data?: OpenDataTokenPagination;
};

export interface OpenDataTokenReactionRequest {
  chain_id?: string;
  address?: string;
}

export type OpenDataTokenReactionResponse = BaseResponse & {
  data?: {
    result?: boolean;
  };
};

/** OpenPostDoc */
export interface OpenPostDoc {
  /** businessId */
  businessId?: string;
  /** platform */
  platform?: string;
  author?: object;
  property?: object;
}

/** Owner info */
export interface Owner {
  /** id */
  id?: string;
  /** osp_address */
  osp_address?: string;
  /** eoa_address */
  eoa_address?: string;
  /** issue_channel */
  issue_channel?: string;
  /** issue_platform */
  issue_platform?: string;
  /**
   * register_time
   * @format int32
   */
  register_time?: number;
  /** handle */
  issue_name?: string;
  /** issue email */
  issue_email?: string;
  /**
   * 已打分的帖子数
   * @format int32
   */
  daily_score_count?: number;
  /** language */
  locale?: string;
  /** issue avatar */
  avatar?: string;
  /** transaction status */
  status?: OwnerStatusEnum;
  /** app_id */
  app_id?: string;
  /**
   * deposit code
   * @deprecated
   */
  deposit_code?: string;
  /** deposit code */
  unique_code?: string;
  /**
   * Invited Count
   * @format int64
   */
  invited_count?: number;
  profile?: Profile[];
}

export type OwnerResponse = BaseResponse & {
  /** Owner info */
  data?: Owner;
};

/** postDoc */
export interface PostDoc {
  /** id */
  id?: string;
  /**
   * time of create
   * @format int64
   */
  created?: number;
  /** title */
  title?: string;
  /** text */
  text?: string;
  /** @format int64 */
  verb?: number;
  /** @format int64 */
  sub_verb?: number;
  user_id?: string;
  community_id?: string;
  user_gid?: string;
  community_gid?: string;
  tag?: string;
  /** @format int32 */
  status?: number;
  medias?: Media[];
  /** @format int64 */
  share_count?: number;
  /** @format int64 */
  like_count?: number;
  /** @format int64 */
  comment_count?: number;
  /** @format int64 */
  reply_count?: number;
  /** @format int64 */
  favorite_count?: number;
  /** @format int64 */
  view_count?: number;
  /** @format int64 */
  megaphone_count?: number;
  content?: string;
  urls?: string;
  profile_id?: string;
  hashtags?: string[];
  content_id?: string;
  /** userDoc */
  user?: UserDoc;
  /** high light */
  highlight?: Record<string, string[]>;
  /** @format int64 */
  privacy?: number;
}

/** profile info */
export interface Profile {
  /** user gid */
  gid?: string;
  chain_id?: string;
  /** profile id */
  profile_id?: string;
  handle?: string;
  bio?: string;
  background?: string;
  /** picture(url,height/width/mimeType...) or NftImage(contractAddress,tokenId,uri) */
  avatar?: string;
  /** todo support? */
  metadata?: object;
  /**
   * owner id
   * @deprecated
   */
  owner?: string;
  /** owner address */
  address?: string;
  attributes?: ProfileAttribute[];
  /** Wear Badge */
  badge?: Badge;
  dispatcher?: Dispatcher;
  /** The follow Condition */
  follow_condition?: object;
  /** Follow nft address */
  follow_nft_address?: string;
  /**
   * 0=unfollow,1=off_chain follow, 2=on_chain follow
   * @format int64
   */
  following?: number;
  /** following token id */
  following_token_id?: string;
  /**
   * 0=unfollow,1=off_chain follow, 2=on_chain follow
   * @format int64
   */
  followed?: number;
  /** @format int64 */
  following_count?: number;
  /** @format int64 */
  chain_following_count?: number;
  /** @format int64 */
  follower_count?: number;
  /** @format int64 */
  chain_follower_count?: number;
  /** @format int64 */
  subscribe_count?: number;
  /** @format int64 */
  activity_count?: number;
  /** @format int64 */
  join_count?: number;
  /** @format int64 */
  activity_like_count?: number;
  /** index id ,use mark data */
  index_id?: string;
  /** user id eq profile id */
  user_id?: string;
  /** displayName or nickName */
  nick_name?: string;
  unique_name?: string;
  /** @format int64 */
  created?: number;
  /** sync status enum */
  sync_status?: SyncStatus;
  /** join tribe role */
  joining_role?: RelationRoleEnum;
  joining_level?: string;
  /** stats */
  stats?: object;
  /** @format int64 */
  post_count?: number;
  /**
   * the count of user score
   * @format int64
   */
  user_date_score_count?: number;
  /** owner information */
  owner_info?: Owner;
}

export interface ProfileAttribute {
  /** The display type */
  display_type?: string;
  /** identifier of this attribute, we will update by this id */
  key?: string;
  /** The trait type - can be anything its the name it will render so include spaces */
  trait_type?: string;
  /** Value attribute */
  value?: string;
}

export interface ProfileDTO {
  /** chain id */
  chain_id?: string;
  /** chain icon */
  chain_icon?: string;
  /** address */
  address?: string;
  /** handle */
  handle?: string;
  /** profile_id */
  profile_id?: string;
  /** avatar */
  avatar?: string;
}

export interface SocialMediaAddress {
  /** website */
  website?: string;
  /** gitbook */
  gitbook?: string;
  /** x */
  x?: string;
  /** string */
  linkedin?: string;
  /** string */
  medium?: string;
}

export interface TokenPool {
  pool_address?: string;
  trade?: TokenPoolTrade;
  quote_symbol?: string;
  dex_image_url?: string;
  chain?: string;
}

export interface TokenPoolTrade {
  vol_5m?: string;
  vol_1h?: string;
  vol_6h?: string;
  vol_24h?: string;
  smart_buy_vol_5m?: string;
  smart_buy_vol_1h?: string;
  smart_buy_vol_6h?: string;
  smart_buy_vol_24h?: string;
  smart_sell_vol_5m?: string;
  smart_sell_vol_1h?: string;
  smart_sell_vol_6h?: string;
  smart_sell_vol_24h?: string;
  price?: string;
  price_change_5m?: string;
  price_change_1h?: string;
  price_change_6h?: string;
  price_change_24h?: string;
  price_change_7d?: string;
  vol_change_5m?: string;
  vol_change_pre_5m?: string;
  vol_change_1h?: string;
  vol_change_pre_1h?: string;
  turnover_rate?: string;
  price_usdt?: string;
  smart_buy_vol_5m_usdt?: string;
  smart_buy_vol_1h_usdt?: string;
  smart_buy_vol_6h_usdt?: string;
  smart_buy_vol_24h_usdt?: string;
  smart_sell_vol_5m_usdt?: string;
  smart_sell_vol_1h_usdt?: string;
  smart_sell_vol_6h_usdt?: string;
  smart_sell_vol_24h_usdt?: string;
  /**
   * vol_24h_usdt
   * @example "0.000000000000000000"
   */
  vol_24h_usdt?: string;
  txns_5m?: string;
  txns_1h?: string;
  txns_6h?: string;
  txns_24h?: string;
}

export interface TopProject {
  /**
   * eval
   * @format double
   */
  eval?: number;
  /** eval_change_cycle */
  eval_change_cycle?: number;
  /**
   * project id
   * @format int32
   */
  project_id?: number;
  /** one liner */
  one_liner?: string;
  /** Logo */
  logo?: string;
  /**
   * rank
   * @format int32
   */
  rank?: number;
  /** root data url */
  root_data_url?: string;
  /** token symbol */
  token_symbol?: string;
  /** project name */
  project_name?: string;
  /** tags */
  tags?: string[];
  contract_address?: {
    /** id */
    id?: string;
    /** token address */
    address?: string;
    /** platform */
    platform?: string;
  }[];
  /** white list favorite */
  favorite?: number;
}

export interface TopProjectPagination {
  /**
   * limit
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * total default 0
   * @format int32
   */
  total?: number;
  /** next token */
  next_token?: string;
  rows?: TopProject[];
}

export type TopProjectPaginationResponse = BaseResponse & {
  data?: TopProjectPagination;
};

export type UnBindsResponse = BaseResponse & {
  data?: boolean;
};

/** userDoc */
export interface UserDoc {
  /** id */
  id?: string;
  /** gid */
  gid?: string;
  /**
   * time of create
   * @format int64
   */
  created?: number;
  /** intro */
  intro?: string;
  /** nick_name */
  nick_name?: string;
  /** unique_name */
  unique_name?: string;
  /** @format int32 */
  type?: number;
  /** avatar */
  avatar?: string;
  /** region */
  region?: string;
  /** kol_intro */
  kol_intro?: string;
  /** kol_background_url */
  kol_background_url?: string;
  /**
   * following_count
   * @format int32
   */
  following_count?: number;
  /**
   * follower_count
   * @format int64
   */
  follower_count?: number;
  /**
   * favorite_count
   * @format int32
   */
  favorite_count?: number;
  /**
   * post_count
   * @format int32
   */
  post_count?: number;
  /**
   * post_count
   * @format int32
   */
  join_count?: number;
  owner_id?: string;
  profile_id?: string;
  follow_nft?: string;
  /** Deprecated when osp_address be use */
  address?: string;
  osp_address?: string;
  joining_community?: JoiningCommunity[];
  /** high light */
  highlight?: Record<string, string[]>;
}

export type undefined = undefined;

export type Enum = any;

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<
  D extends unknown,
  E extends unknown = unknown,
> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string =
    "https://{region}-{environment}.opensocial.{domain}/v2/platform/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Open Social API
 * @version 2.0.0
 * @baseUrl https://{region}-{environment}.opensocial.{domain}/v2/platform/
 *
 * The platform API for Open Social Project
 */
export class OpenApiClient<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  tokenseek = {
    /**
     * @description /tokenseek/dashboard/{type}
     *
     * @tags TokenSeek
     * @name ListOpenDataToken
     * @summary /tokenseek/dashboard/{type}
     * @request GET:/tokenseek/dashboard/{type}
     * @secure
     */
    listOpenDataToken: (
      type:
        | "moonshot"
        | "pumpfun"
        | "watchlist"
        | "trending"
        | "coinmarketcap"
        | "news"
        | "bluechip",
      query: {
        /**
         * page
         * @default 0
         */
        page: number;
        /**
         * limit
         * @default 100
         */
        limit: number;
        /** limit */
        ecosystem?: string;
        /** sort param */
        sort?: "vol_5m" | "vol_1h" | "vol_6h" | "vol_24h" | "modified";
      },
      params: RequestParams = {},
    ) =>
      this.request<OpenDataTokenPaginationResponse, any>({
        path: `/tokenseek/dashboard/${type}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description /tokenseek/reaction
     *
     * @tags TokenSeek
     * @name AddTokenReaction
     * @summary /tokenseek/reaction
     * @request POST:/tokenseek/reaction
     * @secure
     */
    addTokenReaction: (
      data: OpenDataTokenReactionRequest,
      params: RequestParams = {},
    ) =>
      this.request<OpenDataTokenReactionResponse, any>({
        path: `/tokenseek/reaction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description /tokenseek/reaction
     *
     * @tags TokenSeek
     * @name DeleteTokenReaction
     * @summary /tokenseek/reaction
     * @request DELETE:/tokenseek/reaction
     * @secure
     */
    deleteTokenReaction: (
      data: OpenDataTokenReactionRequest,
      params: RequestParams = {},
    ) =>
      this.request<OpenDataTokenReactionResponse, any>({
        path: `/tokenseek/reaction`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description /tokenseek/token/search
     *
     * @tags TokenSeek
     * @name SearchToken
     * @summary /tokenseek/token/search
     * @request GET:/tokenseek/token/search
     * @secure
     */
    searchToken: (
      query: {
        /** keyword */
        keyword: string;
        /**
         * page
         * @default 0
         */
        page: number;
        /**
         * limit
         * @default 100
         */
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<OpenDataTokenPaginationResponse, any>({
        path: `/tokenseek/token/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description facs query
     *
     * @tags TokenSeek
     * @name ListFacs
     * @summary /facs
     * @request GET:/tokenseek/facs
     * @secure
     */
    listFacs: (
      query: {
        /**
         * page
         * @default 0
         */
        page: number;
        /**
         * limit
         * @default 100
         */
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FacPaginationResponse, any>({
        path: `/tokenseek/facs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description top projects
     *
     * @tags TokenSeek
     * @name ListTopProjects
     * @summary /top/projects
     * @request GET:/tokenseek/top/projects
     * @secure
     */
    listTopProjects: (
      query: {
        /**
         * offset
         * @default 0
         */
        offset?: number;
        /**
         * limit
         * @default 100
         */
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TopProjectPaginationResponse, any>({
        path: `/tokenseek/top/projects`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description /tokenseek/kline
     *
     * @tags TokenSeek
     * @name ListKline
     * @summary /tokenseek/kline
     * @request GET:/tokenseek/kline
     * @secure
     */
    listKline: (
      query: {
        /** symbol list */
        symbol: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<KlineResponse, any>({
        path: `/tokenseek/kline`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  bind = {
    /**
     * @description bind
     *
     * @tags Bind
     * @name Bind
     * @summary /binds/{type}
     * @request POST:/bind/{type}
     * @secure
     */
    bind: (
      type: BindTypeEnum,
      query?: {
        /** code or discord token */
        token?: string;
        /** redirect uri */
        redirect_uri?: string;
        /** wallet address */
        address?: string;
        /** wallet platform */
        wallet_platform?: string;
        /** credential */
        credential?: string;
        /**
         * sync history
         * @default false
         */
        sync_history?: boolean;
        /** business type */
        business_type?: BusinessTypeEnum;
        /** chain name */
        chain_name?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<BindResponse, any>({
        path: `/bind/${type}`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description unbind
     *
     * @tags Bind
     * @name Unbind
     * @summary /binds/{type}
     * @request DELETE:/bind/{type}
     * @secure
     */
    unbind: (
      type: BindTypeEnum,
      query?: {
        /** business type */
        business_type?: BusinessTypeEnum;
        /**
         * wallet address
         * @example "0x121321323221321"
         */
        address?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UnBindsResponse, any>({
        path: `/bind/${type}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description getBind
     *
     * @tags Bind
     * @name GetBind
     * @summary /binds/{type}
     * @request GET:/bind/{type}
     * @secure
     */
    getBind: (
      type: BindTypeEnum,
      query?: {
        reverse?: boolean;
        flag?: boolean;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BindResponse, any>({
        path: `/bind/${type}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  binds = {
    /**
     * @description listBind
     *
     * @tags Bind
     * @name ListBind
     * @summary /binds
     * @request GET:/binds
     * @secure
     */
    listBind: (
      query?: {
        /** platform type */
        platform?: BindTypeEnum;
        /**
         * owner ids
         * @maxItems 20
         */
        owner_ids?: string[];
        /**
         * limit for pagination
         * @format int32
         * @min 1
         * @max 20
         */
        limit?: number;
        /** nextToken */
        next_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BindsResponse, any>({
        path: `/binds`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description get bind link
     *
     * @tags Bind
     * @name GetBindLink
     * @summary /binds/{type}/link
     * @request GET:/binds/{type}/link
     * @secure
     */
    getBindLink: (
      type: BindLinkTypeEnum,
      query?: {
        scope?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/binds/${type}/link`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  search = {
    /**
     * @description list
     *
     * @tags SearchV2
     * @name SearchMultiple
     * @summary /search/multiple
     * @request GET:/search/multiple
     * @secure
     */
    searchMultiple: (
      query?: {
        /** search keyWords */
        keywords?: string;
        /** zone */
        zone?: string;
        /** sort */
        sort?: string[];
        /**
         * nextToken for pagination
         * @format int32
         */
        page?: number;
        /**
         * limit for pagination
         * @format int32
         * @min 1
         * @max 20
         */
        limit?: number;
        /** searchType List */
        types?: SearchTypeEnum[];
        /** search params for flat */
        params?: Record<string, any>;
        /** Is it an exact term */
        exact?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocMultiplePaginationResponse, any>({
        path: `/search/multiple`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description searchGroup
     *
     * @tags SearchV2
     * @name SearchGroup
     * @summary /search/groups
     * @request GET:/search/groups
     * @secure
     */
    searchGroup: (
      query?: {
        /** group_key */
        group_key?: string;
        /**
         * top_count for group
         * @format int32
         * @min 1
         * @max 20
         */
        top_count?: number;
        /** search type */
        type?: SearchTypeEnum;
        /** query params for flat */
        query_params?: Record<string, any>;
        /** group params for flat */
        group_params?: Record<string, any>;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocGroupPaginationResponse, any>({
        path: `/search/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  kol = {
    /**
     * @description get kol follow by type
     *
     * @tags TokenSeek
     * @name ListKolFollow
     * @summary /kol/follow
     * @request GET:/kol/follow
     * @secure
     */
    listKolFollow: (
      query?: {
        /**
         * page limit
         * @format int32
         * @default 5
         */
        limit?: number;
        /**
         * page size
         * @format int32
         * @default 5
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<KolFollowPaginationResponse, any>({
        path: `/kol/follow`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  achievement = {
    /**
     * @description badgesClaimable
     *
     * @tags Badge
     * @name BadgesClaimable
     * @summary /badgesClaimable
     * @request GET:/achievement/badges-claimable
     * @secure
     */
    badgesClaimable: (
      query?: {
        /**
         * The badge of get request from the APIS
         * @format int32
         * @min 1
         * @max 20
         */
        limit?: number;
        /** nextToken */
        next_token?: string;
        /** category */
        category?: string;
        /** badge status */
        status?: BadgeStatus;
        /** series id */
        series?: string;
        /** is query max level badge */
        include_max_level?: boolean;
        /** claimable sort */
        claimable_sort?: ClaimableBadgeSortEnum[];
        /** user profile */
        profile_id?: string;
        /** series ids */
        series_ids?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ClaimableBadgePaginationResponse, any>({
        path: `/achievement/badges-claimable`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  owners = {
    /**
     * @description query owner info
     *
     * @tags PlatformOwner
     * @name GetOwnerInfo
     * @summary /owners
     * @request GET:/owners
     * @secure
     */
    getOwnerInfo: (
      query?: {
        /** @default false */
        with_invited_count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<OwnerResponse, any>({
        path: `/owners`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
